
















import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Route } from "vue-router";

import { Getter } from "vuex-class";
import {
  IStateUserInfo,
  ILoginMerchant
} from "../types/interface/User/UserTypes";
import HeaderChips from "./header-chips.vue";
import { IOrderPaging } from "../types/interface/IOrderDto";
import { getOrderStatusForRequestOrderList } from "../libs/utils";
@Component({
  name: "Header",
  components: {
    HeaderChips
  }
})
export default class Header extends Vue {
  @Prop(String) title!: string;
  @Prop({ default: "#ffffff" }) color!: string;
  @Prop() backFnc?: Function;
  showBackButton: boolean = false;
  notShowBackButtonRouteName: Array<string> = [
    "Home",
    "Orders",
    "Menu",
    "Messages",
    "Settings"
  ];

  @Getter("merchId") merchId!: string;
  @Getter("userInfo") userInfo!: IStateUserInfo;
  @Getter("makeAlias") makeAlias!: string;
  @Getter("merchant") merchant!: ILoginMerchant;

  back() {
    if (this.backFnc) {
      this.backFnc();
    } else {
      this.$router.back();
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  private changeRouter(r: Route) {
    if (!r.name) {
      this.showBackButton = false;
      return;
    }

    if (this.notShowBackButtonRouteName.includes(r.name || "")) {
      this.showBackButton = false;
    } else {
      this.showBackButton = true;
    }
  }

  bindingConfig = {
    clientId:
      "542556032036-ln22idtl1c98cea7ck3rha5pi82d1jtv.apps.googleusercontent.com",
    onGoogleAuthSuccess(id_token: string) {
      console.log(id_token);
    },
    onGoogleAuthFail(error: any) {
      console.log(error);
    }
  };
}
